var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SuppliesWrapper',{attrs:{"operations":_vm.operations,"loading":_vm.loading,"pagination":_vm.pagination,"status-list":_vm.statusList,"lost-reason-prefix":"lead_lost_reason_"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }